class CartDrawer extends HTMLElement {
    constructor() {
        super();
        this.handleDrawerClick = this.handleDrawerClick.bind(this);
        this.handleDocumentKeyDown = this.handleDocumentKeyDown.bind(this);
    }

    connectedCallback() {
        this.addEventListener("click", this.handleDrawerClick);
        this.bindOverlayClick();
        this.setHeaderCartIconAccessibility();
    }

    disconnectedCallback() {
        this.removeEventListener("click", this.handleDrawerClick);
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
    }

    bindOverlayClick() {
        const overlay = this.querySelector("#CartDrawer-Overlay");

        if (!overlay || overlay.dataset.clickBound === "true") return;

        overlay.dataset.clickBound = "true";
        overlay.addEventListener("click", () => this.close());
    }

    handleDrawerClick(event) {
        if (!this.classList.contains("active")) return;

        const drawerInner = this.querySelector(".drawer__inner");

        if (drawerInner?.contains(event.target)) return;

        this.close();
    }

    handleDocumentKeyDown(event) {
        if (event.code !== "Escape" || !this.classList.contains("active")) return;

        event.preventDefault();
        this.close();
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector("#cart-icon-bubble");
        if (cartLink) {
            cartLink.setAttribute("role", "button");
            cartLink.setAttribute("aria-haspopup", "dialog");
            cartLink.addEventListener("click", (event) => {
                event.preventDefault();
                this.open(cartLink);
            });
            cartLink.addEventListener("keydown", (event) => {
                if (event.code.toUpperCase() === "SPACE") {
                    event.preventDefault();
                    this.open(cartLink);
                }
            });
        }

        const stickyCartButton = document.querySelector("#sticky-cart-button");
        if (stickyCartButton) {
            stickyCartButton.addEventListener("click", (event) => {
                event.preventDefault();
                this.open(stickyCartButton);
            });
        }
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);

        this.bindOverlayClick();

        setTimeout(() => {
            this.classList.add("animate", "active");
        });

        this.addEventListener(
            "transitionend",
            () => {
                const containerToTrapFocusOn = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
                const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
                trapFocus(containerToTrapFocusOn, focusElement);
            },
            { once: true },
        );

        document.addEventListener("keydown", this.handleDocumentKeyDown);
        document.body.classList.add("overflow-hidden");
    }

    close() {
        this.classList.remove("active");
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
        removeTrapFocus(this.activeElement);
        document.body.classList.remove("overflow-hidden");
    }

    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute("role", "button");
        cartDrawerNote.setAttribute("aria-expanded", "false");

        if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
            cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
        }

        cartDrawerNote.addEventListener("click", (event) => {
            event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
        });

        cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
    }

    renderContents(parsedState) {
        this.querySelector(".drawer__inner").classList.contains("is-empty") && this.querySelector(".drawer__inner").classList.remove("is-empty");
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);

            if (!sectionElement) return;
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });

        setTimeout(() => {
            this.bindOverlayClick();
            this.open();
        });
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: "cart-drawer",
                selector: "#CartDrawer",
            },
            {
                id: "cart-icon-bubble",
            },
            {
                id: "sticky-cart-button",
            },
        ];
    }

    getSectionDOM(html, selector = ".shopify-section") {
        return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define("cart-drawer", CartDrawer);
